// extracted by mini-css-extract-plugin
export default {"spacedMedium":"u0P3GvtxFP5_pYXOTCWU","spacedLarge":"Ki9rklap_NpU0GovdhHB"};